export default __webpack_public_path__ + "static/media/best-templates.6bf8d0bf.png";